/** Report (editor) vs Findings (sidebar) — used for mic toggle + R/F badge. */
export const MIC_TOGGLE_TARGET = {
  REPORT: "editor",
  FINDINGS: "sidebar",
};

/** Badge + next mic start: live session wins while recording, else last editor/findings focus. */
export function resolveMicToggleTarget({
  focusedSurface,
  isEditorMicActive,
  isSidebarRecording,
}) {
  if (isEditorMicActive) return MIC_TOGGLE_TARGET.REPORT;
  if (isSidebarRecording) return MIC_TOGGLE_TARGET.FINDINGS;
  return focusedSurface === MIC_TOGGLE_TARGET.REPORT
    ? MIC_TOGGLE_TARGET.REPORT
    : MIC_TOGGLE_TARGET.FINDINGS;
}

export function getMicToggleLetter(target) {
  return target === MIC_TOGGLE_TARGET.REPORT ? "R" : "F";
}
